<template>
  <div id="app">
    <router-view :api="api" />
    <div class="footer">
      <div class="icon-wrap">
        <router-link to="/account">
          <img
            class="account"
            :class="{ 'active': $route.path==='/account'}"
            src="./assets/account.svg"
            alt
          />
        </router-link>
        <router-link to="/home">
          <img class="home" :class="{ 'active': $route.path==='/home'}" src="./assets/home.svg" alt />
        </router-link>
        <router-link to="/loans">
          <img
            class="lend"
            :class="{ 'active': $route.path==='/loans'}"
            src="./assets/lend.svg"
            alt
          />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
export default {
  name: "app",
  data() {
    return {
      api: null
    };
  },
  created() {
    this.getLiabilities();
  },
  methods: {
    getLiabilities() {
      var getLiabilities = firebase.functions().httpsCallable("getLiabilities");
      getLiabilities().then(result => {
        // Read result of the Cloud Function.
        this.api = result.data;
      });
    }
  }
};
</script>

<style lang="scss">
:root {
  --green: #299b86;
  --orange: #eb5f38;
  --yellow: #e7da8e;
  --mint: #cae7de;
  --sans: "IBM Plex Sans", sans-serif;
  --condensed: "IBM Plex Sans Condensed", sans-serif;
  --serif: "IBM Plex Serif", serif;
  --mono: "IBM Plex Mono", monospace;
}

body {
  margin: 0;
}

.input-container {
  position: relative;
}

input {
  border: 0;
  border-bottom: 2px solid #9e9e9e;
  outline: none;
  transition: 0.2s ease-in-out;
  box-sizing: border-box;
  font-size: 2rem;
}

input[type="text"],
input[type="number"] {
  font-size: 2rem;
  text-align: center;
}

label {
  top: 0;
  left: 0;
  right: 0;
  color: #616161;
  display: flex;
  align-items: center;
  position: absolute;
  font-size: 1rem;
  cursor: text;
  transition: 0.2s ease-in-out;
  box-sizing: border-box;
}

input,
label {
  width: 100%;
  height: 3rem;
  font-size: 1rem;
  font-family: var(--sans);
}

/* Interation */
input:valid,
input:focus {
  border-bottom: 2px solid #26a69a;
}

input:valid + label,
input:focus + label {
  color: #26a69a;
  font-size: 0.8rem;
  top: -30px;
  pointer-events: none;
}

#app {
  button {
    border: 0;
    padding: 0;
    font-family: var(--mono);
    font-weight: bolder;
    background: var(--green);
    font-size: 20px;
    color: white;
    border-radius: 7px;
    box-shadow: 0 7px 0px var(--mint);
    display: inline-block;
    transition: all 0.2s;
    position: relative;
    padding: 20px 25px;
    position: relative;
    top: 0;
    cursor: pointer;
    margin: 1rem 20px;
  }

  button:active {
    top: 3px;
    box-shadow: 0 2px 0px #387796;
    transition: all 0.2s;
  }

  button:focus {outline:none;}

  .footer {
    position: fixed;
    background-color: var(--green);
    bottom: 0px;
    width: 100%;

    .icon-wrap {
      display: flex;
      justify-content: space-around;
      align-items: center;

      .active {
        opacity: 0.5;
      }
    }

    .lend {
      width: 3rem;
    }

    .account,
    .home {
      position: relative;
      top: 0.5rem;
    }
    img {
      width: 2rem;
    }
  }
}
</style>